import { UserData } from '../../../constants';

const DontDoSB = {
  label: 'Savings Bank Interest',
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const sbInvested = Math.round((data.sb / 35) * 1000);
        const sbLoss = data.sb - sbInvested * 0.05;
        return `
        <br /><h5>${
          data.firstName ? `${data.firstName}, ` : ''
        } you lost Rs. ${Math.abs(sbLoss).toLocaleString(
          'en-IN'
        )} last year by just leaving money in your savings account</h5>
        <br />
        <p>See how:</p>
        <table class="styled">
        <tr><th></th><th class="highlighted-red">Savings Bank Account</th><th class="highlighted-green"><small>If you invested in Mutual Funds</small></th></tr>
        <tr>
          <td>Approximate amount left in Savings Account in FY 17-18</td>
          <td class="">Rs. ${sbInvested.toLocaleString('en-IN')}</td>
          <td>Rs. ${sbInvested.toLocaleString('en-IN')}</td>
        </tr>
        <tr>
          <td>Interest you earned</td>
          // @ts-ignore
          <td class="">Rs. ${(data.sb || '0').toLocaleString('en-IN')}</td>
          <td>Rs. ${(sbInvested * 0.18).toLocaleString('en-IN')}</td>
        </tr>
        <tr>
          <td>Inflation is 5% per year.<br /> Finally, you ended up making</td>
          <td class="highlighted-red">Rs. ${(
            data.sb -
            sbInvested * 0.05
          ).toLocaleString('en-IN')}</td>
          <td class="highlighted-green">Rs. ${(
            sbInvested * 0.18 -
            sbInvested * 0.05
          ).toLocaleString('en-IN')}</td>
        </tr>
        </table>
        <br />
        <h6>Don't lose money! Invest in mutual funds instead.<br />In the next step, ClearTax will show you how!</h6>
        `;
      },
    },
  ],
};

export default DontDoSB;



// WEBPACK FOOTER //
// ./components/recommendation/cards/dontDoSB.ts